import React from 'react';
import LWButton from 'components/common/LWButton';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SLWButton = styled(LWButton)`
	${({ $opacity }) => `opacity: ${$opacity};`}
	transition: opacity 0.25s;
`;

function DismissButton({
	action,
	visible = true,
	closeSheet,
	notificationCount,
}) {
	const handleClick = () => {
		if (visible) {
			action();
			if (notificationCount === 1) closeSheet();
		}
	};

	return (
		<SLWButton
			onClick={handleClick}
			variant="textPrimaryDark"
			$opacity={Number(visible)}
		>
			Dismiss
		</SLWButton>
	);
}

DismissButton.propTypes = {
	action: PropTypes.func.isRequired,
	visible: PropTypes.bool,
	closeSheet: PropTypes.func.isRequired,
	notificationCount: PropTypes.number.isRequired,
};

export default DismissButton;
